import { render, staticRenderFns } from "./ScoreDessert.vue?vue&type=template&id=74eecc54&scoped=true&"
import script from "./ScoreDessert.vue?vue&type=script&lang=js&"
export * from "./ScoreDessert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eecc54",
  null
  
)

export default component.exports